/**
 @ngdoc service
 @name mapExtensionTileService
 @description
 factory used by mapTilesJsonData.js to construct tile data into tileData object
 */

(function() {
    'use strict';

    var mapExtensionTileService = function(tileDataFactory) {

        var map = function(rawTileData, commonLabels, objectTilesLabels, lookupValues,requesterData){
            var self = this;

            // Assigning tile factory function with parameters to variable
            var tileFactory = new tileDataFactory.constructTileData(rawTileData, commonLabels, objectTilesLabels, lookupValues,requesterData);
            var requester = requesterData.role.roleType.isProcurer ? "Procurer" : "NonProcurer";
           if(rawTileData.itemCorporateURI){
               tileFactory.addFieldToColumn1(tileFactory.field.newLinkBusinessModelField('jobId', 'itemPrincipleURI', 'itemCorporateURI'));
           }
           else {
               tileFactory.addFieldToColumn1(tileFactory.field.newLinkField('jobId','itemPrincipleURI'));
           }
           if(rawTileData.isPrincipal) {
               tileFactory.addFieldToColumn1(tileFactory.field.newLinkField('candidateName', 'candidateURI'));
               tileFactory.addFieldToColumn2(tileFactory.field.newLinkField('procurerOrgUnitName', 'businessURI'));
            }
            else {
                tileFactory.addFieldToColumn1(tileFactory.field.newField('candidateName'));
            }
            tileFactory.addFieldToColumn1(tileFactory.field.newField('candidateTaxStatus'));

            if(tileFactory.isPrincipal()){
                tileFactory.addFieldToColumn2(tileFactory.field.newField('supplierOrgUnitName'));
            }
            if(!rawTileData.isOriginalBooking) {
                tileFactory.addFieldToColumn2(tileFactory.field.newField('requestingManager'));
                tileFactory.addFieldToColumn2(tileFactory.field.newField('extensionApprover'));
            }
            tileFactory.addFieldToColumn3(tileFactory.field.newField('bookingTitle'));
            if(rawTileData.isPrincipal) {
                tileFactory.addFieldToColumn3(tileFactory.field.newLinkField('hiringManagerName', 'hiringManagerURI'));
            }
            tileFactory.addFieldToColumn3(tileFactory.field.newRatePerUnitField(
                'newPayRate',
                rawTileData.payType.id,
                lookupValues[rawTileData.payType.lookupKey][rawTileData.payType.id]
            ));
            tileFactory.addFieldToColumn3(tileFactory.field.newField('previousEndDate', 'date'));

            tileFactory.addFieldToColumn4(tileFactory.field.newRatePerUnitField('calculateExtensionCost'));
            tileFactory.addFieldToColumn4(tileFactory.field.newRatePerUnitField('calculateBookingCost'));
            tileFactory.addFieldToColumn4(tileFactory.field.newRatePerUnitField('totalFulfilmentCost'));
            if(rawTileData.rejectionReason && rawTileData.extensionStatus =='Rejected') {
                tileFactory.addFieldToColumn4(tileFactory.field.newField('rejectionReason'));
            }
            // Adding status
            //assigneeDisplayNameStatus

            tileFactory.addStatus(tileFactory.status.newCombinedStatus(
                'extensionStatus',
                //Optional based upon permission and only occurs at 'Requested'
                'assigneeDisplayNameStatus',
                //Success
                ['Active', 'Processed', 'Approved'],
                //Danger
                [],
                //Warning - Both states
                ['Requested',['Requested',rawTileData.assigneeDisplayNameStatus]]
            ));
            tileFactory.addStatus(tileFactory.status.newStatus('amendmentStatus'));
            tileFactory.addFieldToColumn4(tileFactory.field.newField('hoursPerDay'));
            return tileFactory.tileData;
        };

        return {
            map : map
        };
    };

    mapExtensionTileService.$inject = ['tileDataFactory'];
    angular.module('app').factory('mapExtensionTileService', mapExtensionTileService);

}());